import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
import { ChevronRight } from '@magalu/stereo-ui-icons';
import Flex from '../../atoms/Flex';
export const Container = styled(Flex).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'background.primaryDark',
  padding: 1
}))``;
export const ChevronRightIcon = styled(ChevronRight).attrs(props => ({
  color: getTextColor('lightest')(props)
}))``;